module.exports = __webpack_public_path__ + "static/media/customShapes.cbed9b43.png";